import type React from 'react';
import { styled } from 'styled-components';

import { useCallbackRef } from '@/js/libs/hooks/useCallbackRef/index.ts';

const UploadLabel = styled.label<{ disabled?: boolean }>`
  color: ${({ theme, disabled }) => (disabled ? theme.colors.grey70_1 : theme.colors.link100)};
  cursor: pointer;
`;

export const UploadInput = ({
  onFileAdd,
  disabled,
  uploadButtonText,
  multiple,
  inputRef,
  accept,
}: {
  onFileAdd: (file: File) => void;
  disabled?: boolean;
  uploadButtonText?: React.ReactNode;
  multiple?: boolean;
  inputRef?: React.Ref<HTMLInputElement>;
  accept?: string;
}) => {
  const onFileInputChange = useCallbackRef((e: React.ChangeEvent<HTMLInputElement>) => {
    const { files } = e.target;
    if (files) {
      for (const file of files) {
        onFileAdd(file);
      }
    }
    e.target.value = '';
  });
  return uploadButtonText ? (
    <UploadLabel disabled={disabled}>
      <input ref={inputRef} type='file' hidden disabled={disabled} onChange={onFileInputChange} multiple={multiple} accept={accept} />
      {uploadButtonText}
    </UploadLabel>
  ) : null;
};
